
document.addEventListener('DOMContentLoaded',()=> {
  document.querySelectorAll('[data-wp-shop]').forEach(root=>{
    const buttons=[...root.querySelectorAll('[data-wp-filter]')];
    const cards=[...root.querySelectorAll('[data-wp-card]')];
    buttons.forEach(btn=>btn.addEventListener('click',()=>{
      buttons.forEach(b=>b.classList.remove('is-active'));btn.classList.add('is-active');
      const f=btn.dataset.wpFilter;
      cards.forEach(card=>card.classList.toggle('is-hidden',f!=='all' && !(card.dataset.wpTags||'').split(' ').includes(f)));
    }));
  });
  document.querySelectorAll('[data-wp-finder]').forEach(root=>{
    const buttons=[...root.querySelectorAll('[data-wp-find]')];
    const cards=[...root.querySelectorAll('[data-wp-find-card]')];
    const run=(f)=>cards.forEach(c=>c.classList.toggle('is-hidden',f!=='all' && !(c.dataset.wpFindTags||'').split(' ').includes(f)));
    buttons.forEach(btn=>btn.addEventListener('click',()=>{buttons.forEach(b=>b.classList.remove('is-active'));btn.classList.add('is-active');run(btn.dataset.wpFind)}));
  });
  document.querySelectorAll('[data-wp-wash-calc]').forEach(root=>{
    const price=root.querySelector('[data-wp-price]'), washes=root.querySelector('[data-wp-washes]'), out=root.querySelector('[data-wp-cost]');
    const render=()=>{const p=Math.max(0,Number(price?.value)||0),w=Math.max(1,Number(washes?.value)||1);if(out)out.textContent='$'+(p/w).toFixed(2)};
    [price,washes].forEach(el=>el?.addEventListener('input',render));render();
  });
});

document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-wp-finish-menu]').forEach(root=>{
    const buttons=[...root.querySelectorAll('[data-wp-finish-button]')];
    const panels=[...root.querySelectorAll('[data-wp-finish-panel]')];
    const activate=id=>{
      buttons.forEach(b=>b.classList.toggle('is-active',b.dataset.wpFinishButton===id));
      panels.forEach(p=>p.classList.toggle('is-active',p.dataset.wpFinishPanel===id));
    };
    buttons.forEach(b=>b.addEventListener('click',()=>activate(b.dataset.wpFinishButton)));
    if(buttons[0]) activate(buttons[0].dataset.wpFinishButton);
  });
});
